import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
// import { GooglePlaceModule } from 'ngx-google-places-autocomplete'; //TODO: Remove this if autocomplete works and we dont this library
import { CommonModule } from '@angular/common';
import { LayoutModule } from '@angular/cdk/layout';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PortalModule } from '@angular/cdk/portal';
import { MatStepperModule } from '@angular/material/stepper';
import { OurFormsModule } from './forms/forms.module';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { EstimateComponent } from './estimate/estimate.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DemoMaterialModule } from '../app/material.module';
import { TransactionStatusComponent } from './transaction-status/transaction-status.component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { HomeComponent } from './home/home.component';
import { EstimateConfirmationComponent } from './estimate-confirmation/estimate-confirmation.component';
import { RegistrationComponent } from './registration/registration.component';
import { GffpComponent } from './gffp/gffp.component';
import { SummaryComponent } from './summary/summary.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { AlertComponent } from './alert/alert.component';
import { CookieService } from 'ngx-cookie-service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ApiInterceptor } from './interceptors/api.interceptor';
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { LoadingService } from './services/loading.service';
import { SummarySectionComponent } from './summary/summary-section/summary-section.component';
import { LocatorMainComponent } from './locator/locator-main.component';
import { PhoneNumberComponent } from './phone-number/phone-number.component';
import { LocationMapComponent } from './locator/location-map/location-map/location-map.component';
import { LocationSearchComponent } from './locator/location-search/location-search/location-search.component';
import { LocationSearchDetailComponent } from './locator/location-search-detail/location-search-detail/location-search-detail.component';
import { LocationSearchResultComponent } from './locator/location-search-result/location-search-result/location-search-result.component';
import { LocationClosingHourComponent } from './locator/location-closing-hour/location-closing-hour.component';
import { FraudWarningComponent } from './fraud-warning/fraud-warning.component';
import { TransactionStatusgModalComponent } from './transaction-status/transaction-status-modal/transaction-status-modal.component';
import { DialogService } from './services/dialog.service';
import { LocationServicesComponent } from './locator/location-services/location-services/location-services.component';

import { ServiceUnavailableComponent } from './service-unavailable/service-unavailable.component';
import { DobDropdownComponent } from './registration/dob-dropdown/dob-dropdown.component';
import { CustomerSupportComponent } from './customer-support/customer-support.component';
import { NgRxStoreModule } from './store/store.module';
import { CardEstimateComponent } from './card-estimatee/card-estimate.component';
import { SharedModule } from './shared/shared.module';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { CustomCountryInputSelectorComponent } from './card-estimatee/custom-country-input-selector/custom-country-input-selector.component';
import { PayoutOptionsComponent } from './card-estimatee/payout-options/payout-options/payout-options.component';
import { LocatorModule } from './locator/locator.module';
import { AmountAndExchangeRateComponent } from './card-estimatee/amount-and-exchange-rate/amount-and-exchange-rate.component';
import { MoreInfoComponent } from './more-info/more-info.component';
import { BasicInfoComponent } from './basic-info/basic-info.component';
import { AddressComponent } from './address/address.component';
import { SubmitButtonComponent } from './shared/submit-button/submit-button.component';
import { DateOfBirthComponent } from './basic-info/date-of-birth/date-of-birth.component';
import { CardSummarySectionComponent } from './summary/card-summary-section/card-summary-section.component';
import { CustomStateInputSelectorComponent } from './card-estimatee/custom-state-input-selector/custom-state-input-selector.component';
import { SignInComponent } from './feature/sign-in/sign-in.component';
import { LoginRegisterComponent } from './feature/sign-in/pages/login-register/login-register.component';
import { RequestOtpComponent } from './feature/sign-in/pages/request-otp/request-otp.component';
import { SubmitOtpComponent } from './feature/sign-in/pages/submit-otp/submit-otp.component';
import { RegisterEmailComponent } from './feature/sign-in/pages/register-email/register-email.component';
import { OtpInputComponent } from './feature/sign-in/pages/submit-otp/otp-input/otp-input.component';
import { UserProfileComponent } from './feature/sign-in/pages/user-profile/user-profile.component';
import { DOBComponent } from './feature/sign-in/pages/user-profile/dob/dob.component';
import { SignInHeaderComponent } from './feature/sign-in/components/sign-in-header/sign-in-header.component';
import { environment } from 'src/environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { ErrorService } from './services/error.service';
import { CountdownTimerComponent } from './feature/sign-in/components/countdown-timer/countdown-timer.component';
import { PaymentMethodComponent } from './feature/payment-method/payment-method.component';
import { RiskSdkComponent } from './feature/risk-sdk/risk-sdk.component';
import { DigitalPaymentComponent } from './feature/digital-payment/digital-payment.component';
@NgModule({
  declarations: [
    AppComponent,
    PayoutOptionsComponent,
    TransactionStatusComponent,
    HomeComponent,
    EstimateComponent,
    CardEstimateComponent,
    EstimateConfirmationComponent,
    RegistrationComponent,
    GffpComponent,
    SummaryComponent,
    ConfirmationComponent,
    AlertComponent,
    SummarySectionComponent,
    PhoneNumberComponent,
    FraudWarningComponent,
    TransactionStatusgModalComponent,
    ServiceUnavailableComponent,
    DobDropdownComponent,
    CustomerSupportComponent,
    CustomCountryInputSelectorComponent,
    AmountAndExchangeRateComponent,
    MoreInfoComponent,
    BasicInfoComponent,
    AddressComponent,
    SubmitButtonComponent,
    DateOfBirthComponent,
    CardSummarySectionComponent,
    CustomStateInputSelectorComponent,
    SignInComponent,
    LoginRegisterComponent,
    RequestOtpComponent,
    SubmitOtpComponent,
    RegisterEmailComponent,
    OtpInputComponent,
    UserProfileComponent,
    DOBComponent,
    SignInHeaderComponent,
    CountdownTimerComponent,
    PaymentMethodComponent,
    RiskSdkComponent,
    DigitalPaymentComponent,
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    BrowserModule,
    NgRxStoreModule,
    SharedModule,
    LocatorModule,
    CommonModule,
    BrowserAnimationsModule,
    PortalModule,
    MatStepperModule,
    OurFormsModule,
    MatButtonModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    DemoMaterialModule,
    HttpClientModule,
    // GooglePlaceModule, //TODO: Remove this if autocomplete works and we dont this library
    HttpClientModule,
    StoreDevtoolsModule.instrument(),
    LayoutModule,
    MatBottomSheetModule,
  ],
  exports: [DemoMaterialModule],
  providers: [
    LoadingService,
    CookieService,
    DialogService,
    ErrorService,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    { provide: MatBottomSheetRef, useValue: {} },
    { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
  ],
  // entryComponents: [TransactionStatusgModalComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
